import {illigalCharacterValidation} from "./IlligalCharactersValidation";

export const validateTitle = (element) => {
    const valid = {
        isValid: true,
        message: ""
    }
    let result = illigalCharacterValidation(element,'Site Name');
    if(!result.isValid)
    {
        return result;
    }

    const maxLength = 90;
    if (element && element.length > maxLength) {
        valid.isValid = false;
        valid.message = `Maximum length should be less than ${maxLength} characters`;
    }
    return valid;
}


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Validation/TitleValidation.js